<ng-content contenteditable="false"></ng-content>